module.exports = __webpack_public_path__ + "img/4.672280ff.jpg";